import { render, staticRenderFns } from "./editLicence.vue?vue&type=template&id=1b930d33&scoped=true"
import script from "./editLicence.vue?vue&type=script&lang=js"
export * from "./editLicence.vue?vue&type=script&lang=js"
import style0 from "./editLicence.vue?vue&type=style&index=0&id=1b930d33&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b930d33",
  null
  
)

export default component.exports